__turbopack_context__.v({
  "downloadBox": "Njkv9W_downloadBox",
  "download__Item": "Njkv9W_download__Item",
  "download__anchor": "Njkv9W_download__anchor",
  "download__file-name": "Njkv9W_download__file-name",
  "download__icon": "Njkv9W_download__icon",
  "download__link": "Njkv9W_download__link",
  "download__meta-data": "Njkv9W_download__meta-data",
  "imageWrapper": "Njkv9W_imageWrapper",
  "multiple": "Njkv9W_multiple",
  "single": "Njkv9W_single",
});
